/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import Cookies from 'js-cookie';
import numeral from 'numeral';
import { spaFullString } from './amount';
import { PROPERTY_CATEGORY_HIGH_RISE } from '../constants/propertyCategories';
import { isVietnamCountryCode } from './areaLabel';

function getAreaText(user) {
  const countryCode = user && user.company && user.company.countryCode;
  return isVietnamCountryCode(countryCode) ? 'Net Floor Area' : 'Build Up Area';
}

function checkSizeSuffix(suffix, user) {
  switch (suffix) {
    case 'square_metres':
      return isVietnamCountryCode(user && user.company && user.company.countryCode) ? ' m²' : ' sqm';
    case 'square_feet':
      return ' sqft';
    default:
      return '';
  }
}

function formatAmount(amount = '-', format) {
  let loan;
  if (amount === '-') {
    return 'N/A';
  }
  if (format) {
    loan = numeral(amount).format(format);
  } else {
    loan = ((amount * 1) >= 1000000 && (amount * 1) < 100000000 ?
      numeral(amount).format('0.0a') :
      numeral(amount).format('0a'));
  }
  return loan;
}

function fAmount(amount = 0) {
  let currency = 'RM';
  const cookieCurrency = Cookies.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  let format = '000,000,000.00';
  if (amount < 100) format = '0.00';
  if (amount < 100000) format = '0,000.00';
  return `${currency} ${formatAmount(amount, format)}`;
}

function getInitialBookingPackagePrice(packagePricing, calculatedPackagePricings = []) {
  const calculatedPackagePricing = calculatedPackagePricings.find(p => p.id === packagePricing.id);
  const calculations = calculatedPackagePricing && !calculatedPackagePricing.isCustomPrice &&
    calculatedPackagePricing.projectPackagePricing && calculatedPackagePricing.projectPackagePricing.packagePricingCalculations;
  const applicableCalculations = calculations && calculations.filter(calculation =>
    calculation.applyToBooking &&
    (!calculation.projectPackagePricingItem || calculation.projectPackagePricingItem.isEnabled));

  if (applicableCalculations && applicableCalculations.length > 0) {
    return applicableCalculations[applicableCalculations.length - 1].newValue;
  }
  if (calculations) return packagePricing.spaPrice;
  return packagePricing.totalPrice;
}

export function shareUnitCopyFormat(unit, user, calculatedPackagePricings = []) {
  let currency = 'RM';
  const cookieCurrency = Cookies.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  let fullText = '';
  if (!unit) return fullText;
  const areaText = getAreaText(user);
  let unitInfo = 'Unit Information\n';
  unitInfo += `${unit.project && unit.project.name ? `• Project Name: ${unit.project.name}\n` : ''}`;
  unitInfo += `${unit.reference ? `• Unit Number: ${unit.reference}\n` : ''}`;
  unitInfo += `${unit.projectUnitLayout && unit.projectUnitLayout.name ? `• Layout Type: ${unit.projectUnitLayout.name}\n` : ''}`;
  unitInfo += `${unit.size ? `• ${areaText}: ${parseFloat(unit.size)}${checkSizeSuffix(unit.project.sizeSuffix, user)}\n` : ''}`;
  unitInfo += `${unit.landArea ? `• LandArea: ${unit.landArea}\n` : ''}`;
  unitInfo += `${unit.streetNumberOrLevel ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:'} ${unit.streetNumberOrLevel}\n` : ''}`;
  unitInfo += `${unit.zoneOrBlock ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:'} ${unit.zoneOrBlock}\n` : ''}`;
  unitInfo += `${unit.streetOrFacing ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:'} ${unit.streetOrFacing}\n` : ''}`;
  unitInfo += `${unit.spaValue ? `• Selling Price: ${currency} ${spaFullString(unit, '000,000,000.00')}\n` : ''}`;
  fullText += unitInfo;
  if (unit.projectUnitLayout && unit.projectUnitLayout.specifications && unit.projectUnitLayout.specifications.length > 0) {
    let layoutType = '\nLayout Type\n';
    unit.projectUnitLayout.specifications.forEach((s, i) => {
      if (i + 1 > 3) return;
      layoutType += `• ${s.name}: ${s.value}\n`;
    });
    fullText += layoutType;
  }
  if (unit.specifications && unit.specifications.length > 0) {
    let unitSpecs = '\nUnit Specifications \n';
    unit.specifications.forEach((s) => {
      unitSpecs += `• ${s.name}: ${s.value}\n`;
    });
    fullText += unitSpecs;
  }
  if (unit.spaValue && unit.projectUnitPackagePricings && unit.projectUnitPackagePricings.length > 0) {
    let unitPricing = '\nUnit Pricing Packages \n';
    unit.projectUnitPackagePricings.forEach((pp, id) => {
      if (id > 0) unitPricing += '\n';
      unitPricing += `${id + 1}) ${(pp.projectPackagePricing && pp.projectPackagePricing.name) ? pp.projectPackagePricing.name : pp.customName}\n`;
      unitPricing += `${(pp.projectPackagePricing && pp.projectPackagePricing.description) ? `${pp.projectPackagePricing.description}\n` : (pp.customDescription ? `${pp.customDescription}\n` : '')}`;
      unitPricing += `${currency} ${formatAmount(getInitialBookingPackagePrice(pp, calculatedPackagePricings), '000,000,000.00')}\n`;
    });
    fullText += unitPricing;
  }
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += `\nShared by ${user.preferredName}\n`;
    fullText += `Generated by MHub on behalf of ${user.company.name}\n`;
  }
  return fullText;
}

export function shareUnitToWSFormat(unit, user, calculatedPackagePricings = []) {
  let currency = 'RM';
  const cookieCurrency = Cookies.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  let fullText = '';
  if (!unit) return fullText;
  const areaText = getAreaText(user);
  let unitInfo = '🏠 _Unit Information_ \n';
  unitInfo += `${unit.project && unit.project.name ? `• *Project Name:* ${unit.project.name}\n` : ''}`;
  unitInfo += `${unit.reference ? `• *Unit Number:* ${unit.reference}\n` : ''}`;
  unitInfo += `${unit.projectUnitLayout && unit.projectUnitLayout.name ? `• *Layout Type:* ${unit.projectUnitLayout.name}\n` : ''}`;
  unitInfo += `${unit.size ? `• *${areaText}:* ${parseFloat(unit.size)}${checkSizeSuffix(unit.project.sizeSuffix, user)}\n` : ''}`;
  unitInfo += `${unit.landArea ? `• *LandArea:* ${unit.landArea}\n` : ''}`;
  unitInfo += `${unit.streetNumberOrLevel ? `• *${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:'}* ${unit.streetNumberOrLevel}\n` : ''}`;
  unitInfo += `${unit.zoneOrBlock ? `• *${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:'}* ${unit.zoneOrBlock}\n` : ''}`;
  unitInfo += `${unit.streetOrFacing ? `• *${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:'}* ${unit.streetOrFacing}\n` : ''}`;
  unitInfo += `${unit.spaValue ? `• *Selling Price:* ${currency} ${spaFullString(unit, '000,000,000.00')}\n` : ''}`;
  fullText += unitInfo;
  if (unit.projectUnitLayout && unit.projectUnitLayout.specifications && unit.projectUnitLayout.specifications.length > 0) {
    let layoutType = '\n🚪 _Layout Type_ \n';
    unit.projectUnitLayout.specifications.forEach((s, i) => {
      if (i + 1 > 3) return;
      layoutType += `• *${s.name}:* ${s.value}\n`;
    });
    fullText += layoutType;
  }
  if (unit.specifications && unit.specifications.length > 0) {
    let unitSpecs = '\n🗒️ _Unit Specifications_ \n';
    unit.specifications.forEach((s) => {
      unitSpecs += `• *${s.name}:* ${s.value}\n`;
    });
    fullText += unitSpecs;
  }
  if (unit.spaValue && unit.projectUnitPackagePricings && unit.projectUnitPackagePricings.length > 0) {
    let unitPricing = '\n⭐ _Unit Pricing Packages_ \n';
    unit.projectUnitPackagePricings.forEach((pp, id) => {
      if (id > 0) unitPricing += '\n';
      unitPricing += `*${id + 1}) ${(pp.projectPackagePricing && pp.projectPackagePricing.name) ? pp.projectPackagePricing.name : pp.customName}*\n`;
      unitPricing += `${(pp.projectPackagePricing && pp.projectPackagePricing.description) ? `_${pp.projectPackagePricing.description}_\n` : (pp.customDescription ? `_${pp.customDescription}_\n` : '')}`;
      unitPricing += `*${currency} ${formatAmount(getInitialBookingPackagePrice(pp, calculatedPackagePricings), '000,000,000.00')}*\n`;
    });
    fullText += unitPricing;
  }
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += `\n_Shared by *${user.preferredName}*_\n`;
    fullText += `_Generated by MHub on behalf of ${user.company.name}_\n`;
  }
  return encodeURIComponent(fullText).replace(/'/g, '%27').replace(/"/g, '%22');
}

export function shareUnitMorCalcCopyFormat(unit, calcVal, loanMargin, result, user, pricingPackage) {
  let fullText = '';
  if (!unit) return fullText;
  const areaText = getAreaText(user);
  let unitInfo = '*Unit Information* \n';
  unitInfo += `${unit.project && unit.project.name ? `• Project Name: ${unit.project.name}\n` : ''}`;
  unitInfo += `${unit.reference ? `• Unit Number: ${unit.reference}\n` : ''}`;
  unitInfo += `${unit.projectUnitLayout && unit.projectUnitLayout.name ? `• Layout Type: ${unit.projectUnitLayout.name}\n` : ''}`;
  unitInfo += `${unit.size ? `• ${areaText}: ${parseFloat(unit.size)}${checkSizeSuffix(unit.project.sizeSuffix, user)}\n` : ''}`;
  unitInfo += `${unit.landArea ? `• LandArea: ${unit.landArea}\n` : ''}`;
  unitInfo += `${unit.streetNumberOrLevel ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:'} ${unit.streetNumberOrLevel}\n` : ''}`;
  unitInfo += `${unit.zoneOrBlock ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:'} ${unit.zoneOrBlock}\n` : ''}`;
  unitInfo += `${unit.streetOrFacing ? `• ${unit.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:'} ${unit.streetOrFacing}\n` : ''}`;
  fullText += unitInfo;
  let unitMCalc = '\n*Mortgage Calculator* \n';
  unitMCalc += `• SPA Price: ${fAmount(calcVal.spaPrice)}\n`;
  unitMCalc += `• Pricing Package name: ${pricingPackage !== 'spa_value' ? pricingPackage : 'Base Unit Price'}\n`;
  unitMCalc += `• Loan margin: ${loanMargin}%\n`;
  unitMCalc += `• Loan tenure: ${calcVal.tenureYear} years\n`;
  unitMCalc += `• Interest rate: ${calcVal.interestRate}%\n`;
  fullText += unitMCalc;
  let unitEstCalc = '\n*Estimated Calculation* \n';
  unitEstCalc += `Estimated monthly payment: ${fAmount(result.monthlyLoanPayment)}\n`;
  unitEstCalc += `\nSPA: ${fAmount(result.totalSPAFees)}\n`;
  unitEstCalc += `• Legal fee (Property value): ${fAmount(result.spaLegalFee)}\n`;
  unitEstCalc += `• Legal fee SST (8%): ${fAmount(result.spaLegalFeeSST)}\n`;
  unitEstCalc += `• Legal disbursements*: ${fAmount(result.spaLegalFeeDisbursements)}\n`;
  unitEstCalc += `\nLoan agreement: ${fAmount(result.totalLAFees)}\n`;
  unitEstCalc += `• Legal fee (Loan amount): ${fAmount(result.laLegalFee)}\n`;
  unitEstCalc += `• Legal fee SST (8%): ${fAmount(result.laLegalFeeSST)}\n`;
  unitEstCalc += `• Legal disbursements: ${fAmount(result.laLegalFeeDisbursements)}\n`;
  unitEstCalc += `• Stamp duty: ${fAmount(result.laStampDuty)}\n`;
  unitEstCalc += `\nValuation fees: ${fAmount(result.totalValuationFees)}\n`;
  unitEstCalc += `• Valuation fees (Property value): ${fAmount(result.valuationFee)}\n`;
  unitEstCalc += `• Valuation fees SST (8%): ${fAmount(result.valuationFeeSST)}\n`;
  unitEstCalc += `• Disbursements*: ${fAmount(result.valuationFeeDisbursements)}\n`;
  unitEstCalc += '\nInstrument of transfer (MoT / DoA)\n';
  unitEstCalc += `• Stamp duty: ${fAmount(result.motStampDuty)}\n`;
  unitEstCalc += `\nEstimated total additional cost: ${fAmount(result.totalAdditionalFees)}\n`;
  unitEstCalc += '* Actual amount may vary\n';
  fullText += unitEstCalc;
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += `\nShared by ${user.preferredName}\n`;
    fullText += `Generated by MHub on behalf of ${user.company.name}\n`;
  }
  return fullText;
}



// WEBPACK FOOTER //
// ./src/utils/sharing.js